import React, { useEffect, useState } from 'react';
import { ErrorPanel } from '../../design/error';
import { DataContentProps } from '../../content/types';
import { DEFAULT_ERROR_MESSAGE, DEFAULT_ERROR_TITLE } from '../../common/constants/error';
import { flushErrors } from '../../tools/axios.trace';

function DataErrorElement({ error: { title, className, message } }: Readonly<Partial<DataContentProps>>) {
  const [errorString, setErrorString] = useState<string>('');
  const safeMessage = isValidMessage(message) ? message : DEFAULT_ERROR_MESSAGE;
  const safeTitle = isValidMessage(title) ? title : DEFAULT_ERROR_TITLE;

  useEffect(() => {
    const errors = flushErrors();
    if (errors.length) {
      setErrorString(errors);
    }
  }, []);

  return (
    <div className={className}>
      <ErrorPanel>
        <ErrorPanel.Title title={safeTitle} />
        <ErrorPanel.ServerResponse
          response={
            safeMessage + '<br /><br /><small>' + new Date().toUTCString() + '<br />' + errorString + '</small>'
          }
        />
      </ErrorPanel>
    </div>
  );
}
export { DataErrorElement };
const isValidMessage = (message: string): boolean => {
  const inappropriateKeys = ['DOCTYPE', 'html', 'Error'];
  return !inappropriateKeys.some(key => message.includes(key));
};
